module.exports = {
    classNames: {
      appeventLink: "alme--window--footer__links__link",
      logoFooterLink: "alme--window--footer__links__logo",
      resizeIcon: "alme--window--footer__links__resize",
      subBannerClassName: "alme--window--header--sub--banner",
      surveyInput: "alme--window--survey__input",
      livechat: {
        messageReceivedText: "alme--livechat--conversation--message-received__text",
        chatBannerConnectContainer: 'alme--livechat--banner--connect--container',
        chatBannerConnectPrimary: 'alme--livechat--banner--connect--primary',
        chatBannerConnectSecondary: 'alme--livechat--banner--connect--secondary',
        chatBannerConnectAdditional: 'alme--livechat--banner--connect--additional',
        chatBannerDisconnectContainer: 'alme--livechat--banner--disconnect--container',
        chatBannerDisconnectPrimary: 'alme--livechat--banner--disconnect--primary',
        chatBannerDisconnectSecondary: 'alme--livechat--banner--disconnect--secondary',
        chatBannerDisconnectAdditional: 'alme--livechat--banner--disconnect--additional',
        endChatLink: 'alme--livechat--endchat',
        endChatLinkContainer: 'alme--livechat--endchatcontainer',
        headerBannerText: 'alme--livechat--window--header--banner',
        inputContainer: 'alme--livechat--conversation--input',
        inputDisplayName: 'alme--livechat--conversation--input--message__displayname',
        inputMessage: 'alme--livechat--conversation--input--message',
        inputPersonaIcon: 'alme--livechat--conversation--input--personaicon',
        inputText: 'alme--livechat--conversation--input--message__text',
        responseContainer: 'alme--livechat--conversation--response',
        responseDisplayName: 'alme--livechat--conversation--response--message__displayname',
        responseError: 'alme--livechat--response--error',
        responseInlineLink: "alme--livechat--conversation--response--message__link",
        responseMessage: 'alme--livechat--conversation--response--message',
        responsePersonaIcon: 'alme--livechat--conversation--response--personaicon',
        responseText: 'alme--livechat--conversation--response--message__text',
        typingNotification: 'alme--livechat--typingnotification',
    },
    almeResponseErrorClassName: 'alme--response--error',
    almeResponseMessageClassName: 'alme--window--conversation--response--alme__message',
    conversationAreaClassName: 'alme--window--conversation',
    displayLink: 'alme--window--conversation--response--alme__message__displayLinks__link',
    navigationLink: 'alme--window--conversation--response--alme__message__navigationlink',
    windowClassName: 'alme--window',
    disclaimerClassName: "alme--window--footer--disclaimer",
    },
};


// WEBPACK FOOTER //
// ./settings/class-names.js